module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_phone_number_for":"Add phone number for sign in","tac":"TAC","six_digit_tac_number":"6 digit TAC Number"},"id":{"add_phone_number_for":"Tambah nomor HP untuk log in","tac":"TAC","six_digit_tac_number":"6 digit nomor TAC"}}')
  delete Component.options._Ctor
}
